import React from 'react';
import Cards from '../Cards';

function Projects() {
  return (
    <div id="projects">
      <Cards />
    </div>
  );
}

export default Projects;
